"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonPathTransformer = JsonPathTransformer;
function JsonPathTransformer(options) {
    return data => { };
}
//# sourceMappingURL=jsonpath-transformer.js.map